"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _DropdownPresenter2 = _interopRequireDefault(require("./DropdownPresenter"));
var _MultiSelectionPresenter = _interopRequireDefault(require("./MultiSelectionPresenter"));
var _ReservedOptions = require("./ReservedOptions");
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MultiSelectionAllAsReservedPresenter = exports["default"] = /*#__PURE__*/function (_DropdownPresenter) {
  function MultiSelectionAllAsReservedPresenter(i18n) {
    var _this;
    (0, _classCallCheck2["default"])(this, MultiSelectionAllAsReservedPresenter);
    _this = _callSuper(this, MultiSelectionAllAsReservedPresenter, [i18n]);
    _this.multipleSelectionPresenter = new _MultiSelectionPresenter["default"](i18n);
    return _this;
  }
  (0, _inherits2["default"])(MultiSelectionAllAsReservedPresenter, _DropdownPresenter);
  return (0, _createClass2["default"])(MultiSelectionAllAsReservedPresenter, [{
    key: "DropdownButton",
    get: function get() {
      return this.multipleSelectionPresenter.DropdownButton;
    }
  }, {
    key: "menuCollapseBehavior",
    get: function get() {
      return this.multipleSelectionPresenter.menuCollapseBehavior;
    }
  }, {
    key: "emitValue",
    value: function emitValue(valueSelected, prevValue, children) {
      if (valueSelected === _ReservedOptions.ReservedOptions.All) {
        return prevValue === _ReservedOptions.ReservedOptions.All || this.multipleSelectionPresenter.isAllItemSelected(prevValue, children) ? null : _ReservedOptions.ReservedOptions.All;
      }
      var result = this.multipleSelectionPresenter.emitValue(valueSelected, this.parseToActualValues(prevValue, children), children);
      return this.multipleSelectionPresenter.isAllItemSelected(result, children) ? _ReservedOptions.ReservedOptions.All : result;
    }
  }, {
    key: "parseToActualValues",
    value: function parseToActualValues(value, children) {
      return value === _ReservedOptions.ReservedOptions.All ? this.multipleSelectionPresenter.getAllOptionValues(children) : value;
    }
  }, {
    key: "isItemSelected",
    value: function isItemSelected(itemValue, value, children) {
      return value === _ReservedOptions.ReservedOptions.All || this.multipleSelectionPresenter.isItemSelected(itemValue, value, children);
    }
  }, {
    key: "renderDefaultLabel",
    value: function renderDefaultLabel(value, children) {
      return value === _ReservedOptions.ReservedOptions.All ? this.i18n('react-ui.common.dropdown.label.multi.all.selected') : this.multipleSelectionPresenter.renderDefaultLabel(value, children);
    }
  }, {
    key: "renderChildren",
    value: function renderChildren(value, children) {
      return this.multipleSelectionPresenter.renderChildren(value, children);
    }
  }]);
}(_DropdownPresenter2["default"]);